import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map, TileLayer } from 'react-leaflet';
import DivIcon from 'react-leaflet-div-icon';

import { getCentroidFromGeoJson } from './../../utils';

import {MAP_ATTRIBUTION, MAP_URL, SHOW_PARKING_SPOTS_ZOOM_LEVEL, DEFAULT_MAP_POSITION} from './../../constants';

import ParkingSpotsLayer from './ParkingSpotsLayer';

class SpotMap extends Component {

  render() {
    const {parkingSpotsLayer, mapCenter, spotId, markerCoordinates} = this.props;

    return (
      <div className="spot-map">
        <div className="overlay" />
        <Map
          center={mapCenter}
          zoom={SHOW_PARKING_SPOTS_ZOOM_LEVEL}
          minZoom={SHOW_PARKING_SPOTS_ZOOM_LEVEL}
          zoomControl={false}
        >
          <TileLayer
            attribution={MAP_ATTRIBUTION}
            url={MAP_URL}
          />

          {
            parkingSpotsLayer.map((layer, index) => <ParkingSpotsLayer key={index} data={layer.geojson} spotId={spotId} />)
          }

          {markerCoordinates && (
            <DivIcon position={markerCoordinates} className="spot-marker-container marker-pin-wrap">
                <div className="spot-marker-wrap">
                    <div className="marker-icon-div i-icon-marker-pin-focus" />
                </div>
            </DivIcon>)
          }
        </Map>
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  const { parkingSpotFeaturesList } = state.session;
  const { spotId } = ownProps;
  const feature = parkingSpotFeaturesList[spotId];
  let mapCenter = DEFAULT_MAP_POSITION;
  let markerCoordinates = null;

  if(feature){
    markerCoordinates = feature.centerCoordinates;
    mapCenter = [markerCoordinates.lat, markerCoordinates.lng];
  }

  return {
    mapCenter,
    markerCoordinates,
    parkingSpotsLayer: state.geoJsonData.parkingSpots
  };
};

export default connect(mapStateToProps)(SpotMap);



// WEBPACK FOOTER //
// ./src/containers/SpotMap/index.js